<div class="ui-combobox"
     ngbDropdown
     (openChange)="handleOpen()">
    <div ngbDropdownToggle>
        <input
            type="text"
            class="js-ui-combobox__field ui-combobox__field"
            autocomplete="off"
            placeholder="{{defaultText}}"
            [value]="getSelected()"
            (input)="changeInput($event)"
            name="{{name}}"
            id="{{name}}"
            fieldTrim
            [disabled]="isDisabled"
        >
        <button type="button" class="ui-combobox__corner" [disabled]="isDisabled"></button>
    </div>
    <div ngbDropdownMenu *ngIf="!isDisabled && (items).length">
        <button *ngFor="let item of items"
                (click)="chooseItem(item);$event.stopPropagation()">
            <ui-checkbox>
                <input type="checkbox" [checked]="item.checked" (click)="chooseItem(item)">
                <checkbox-text class="color-blue-dark">{{item[textKey] || item}}</checkbox-text>
            </ui-checkbox>
        </button>
    </div>
    <div
      *ngIf="isCanSelectAll"
      class="link link--dotted mt-8"
      style="display: inline-block"
      (click)="onClickSelectAllItems()"
    >
      {{isAllItemsSelected ? 'Снять выделение' : 'Выбрать все'}}
    </div>
</div>
